import { defineComponent, renderSlot } from 'vue'
import { buildProps, definePropType, mutable } from '@pit-element-plus/utils'
import { UPDATE_MODEL_EVENT } from '@pit-element-plus/constants'
import tabsCard from './tabsCard.vue'
import tabsLine from './tabsLine.vue'
import type { BaseTabsPaneContext } from './constants'
import type { ExtractPropTypes } from 'vue'

export interface TabListData {
  name: string | number
  label: string | number
}

export type TabListDatas = TabListData[]

export const baseTabsProps = buildProps({
  modelValue: {
    type: [String, Number],
  },
  tabListData: {
    type: definePropType<TabListDatas>(Array),
    default: () => mutable([]),
  },
  noCard: {
    type: Boolean,
    default: false,
  },
} as const)

export type BaseTabsProps = ExtractPropTypes<typeof baseTabsProps>

export const baseTabsEmits = {
  [UPDATE_MODEL_EVENT]: (name: string | number) => name,
  change: (name: string | number) => name,
}
export type BaseTabsEmits = typeof baseTabsEmits

export type BaseTabsPanes = Record<number, BaseTabsPaneContext>

export default defineComponent({
  name: 'ElBaseTabs',

  components: {
    tabsCard,
    tabsLine,
  },

  props: baseTabsProps,
  emits: baseTabsEmits,

  setup(props: BaseTabsProps, { emit, slots }) {
    const handleChange = function (val: string | number) {
      emit('update:modelValue', val)
      emit('change', val)
    }
    return () => {
      if (props.noCard) {
        return (
          <tabsLine
            v-model={props.modelValue}
            tabListData={props.tabListData}
            noCard={props.noCard}
            onChange={handleChange}
          >
            {renderSlot(slots, 'default')}
          </tabsLine>
        )
      } else {
        return (
          <tabsCard
            v-model={props.modelValue}
            tabListData={props.tabListData}
            noCard={props.noCard}
            onChange={handleChange}
          >
            {renderSlot(slots, 'default')}
          </tabsCard>
        )
      }
    }
  },
})
